module.exports = __webpack_public_path__ + "static/media/feature2structure.ff32e9c3.png";